/**
 * Compare tools page tour
 */

export const COMPARE_TOUR_STEPS = [
  {
    id: 'welcome',
    title: 'Compare tools',
    description:
      'Put up to three Apps or Gems side by side so you can pick the right one — or see how they pair.',
    position: 'center',
  },
  {
    id: 'columns',
    title: 'Side-by-side columns',
    description:
      'Each column is one tool. Rows line up (roles, stages, capabilities, usage) so differences are easy to spot.',
    element: '[data-tour="compare-columns"]',
    position: 'top',
    spotlight: true,
  },
  {
    id: 'swap',
    title: 'Swap or add a tool',
    description:
      'Use the refresh icon on a column to swap that tool, or Add tool to fill an empty slot (max 3).',
    element: '[data-tour="compare-swap-or-add"]',
    position: 'left',
    spotlight: true,
  },
  {
    id: 'usage-rows',
    title: 'Usage and quality',
    description:
      'Sessions and ratings help you see which tool is getting traction — winners are highlighted when they lead.',
    element: '[data-tour="compare-usage"], [data-tour="compare-columns"]',
    position: 'top',
    spotlight: true,
  },
];
